/**
 * Friendly German copy for AccessTokens.jsx (this component hardcodes German
 * strings throughout rather than going through i18next — see the eu-routing
 * stage's note on KEY_META; kept consistent here).
 *
 * `reason` is one of key-validator.js's CHECKS results: ok | http_NNN |
 * api_key_invalid | timeout | network_error | unsupported_provider |
 * empty_key | malformed_key. PUT /api/secrets/me|tenant/:key answers 422
 * {error:'invalid_key', reason} on a clear refusal.
 */
export function invalidKeyMessage(reason) {
  if (reason === 'api_key_invalid') {
    return 'Der Anbieter hat diesen Schlüssel abgelehnt — bitte prüfen und erneut eingeben.';
  }
  if (reason === 'empty_key') {
    return 'Bitte einen Schlüssel eingeben.';
  }
  if (reason === 'malformed_key') {
    return 'Der Schlüssel enthält unzulässige Zeichen (Leerzeichen, Zeilenumbruch oder Sonderzeichen) — bitte erneut kopieren und einfügen.';
  }
  if (reason === 'timeout') {
    return 'Der Anbieter hat nicht rechtzeitig geantwortet. Versuch es gleich noch einmal.';
  }
  if (reason === 'network_error') {
    return 'Der Schlüssel konnte nicht geprüft werden (keine Verbindung zum Anbieter).';
  }
  if (reason === 'unsupported_provider') {
    return 'Für diesen Anbieter ist keine automatische Prüfung möglich.';
  }
  if (typeof reason === 'string' && reason.startsWith('http_')) {
    return `Der Anbieter hat den Schlüssel mit Status ${reason.slice(5)} abgelehnt.`;
  }
  return 'Dieser Schlüssel wurde vom Anbieter abgelehnt.';
}

/**
 * Any other refusal of PUT /api/secrets/me|tenant/:key, by its `error` code.
 * Codes without copy of their own stay readable as they are.
 */
export function saveRefusalMessage(error) {
  if (error === 'provider_not_allowed') {
    return 'Die KI-Richtlinie dieses Mandanten lässt diese Ollama-URL nicht zu: Bei aktiver EU-Beschränkung zählt nur ein Server, den der Betreiber freigegeben hat.';
  }
  if (error === 'user_keys_disabled') {
    return 'Die KI-Richtlinie dieses Mandanten erlaubt keine persönlichen KI-Zugänge.';
  }
  if (error === 'policy_unavailable') {
    return 'Die KI-Richtlinie dieses Mandanten ist gerade nicht lesbar. Versuch es in Kürze erneut.';
  }
  return error || 'Speichern fehlgeschlagen';
}

/**
 * PUT /api/secrets/me|tenant/:key answers 422 {error:'unsafe_url', reason}
 * for an ollama_url the outbound-URL guard refuses (outboundUrlViolation()
 * in routes/secrets.js) — a separate refusal from 422 invalid_key (a
 * provider rejecting a key), with its own reason vocabulary
 * (src/server/security/outbound-url.js: `reject(reason)`).
 */
export function unsafeUrlMessage(reason) {
  if (reason === 'invalid_url') {
    return 'Das ist keine gültige URL.';
  }
  if (reason === 'unsupported_scheme') {
    return 'Nur http:// und https:// sind erlaubt.';
  }
  if (reason === 'userinfo') {
    return 'Die URL darf keinen Benutzernamen oder ein Passwort enthalten.';
  }
  if (reason === 'blocked_address') {
    return 'Diese Adresse ist gesperrt (z. B. ein internes oder privates Netz). Wende dich an deine Administration, falls dieser Server erlaubt sein soll.';
  }
  if (reason === 'unresolvable') {
    return 'Der Servername konnte nicht aufgelöst werden.';
  }
  if (reason === 'path_not_allowed') {
    return 'Dieser Pfad ist für Ollama-Server nicht erlaubt.';
  }
  return 'Diese URL wurde aus Sicherheitsgründen abgelehnt.';
}

export default invalidKeyMessage;
